import { useTheme } from '@mui/material'
import JsonViewer from '@uiw/react-json-view'
import { darkTheme } from '@uiw/react-json-view/dark'
import { lightTheme } from '@uiw/react-json-view/light'

export type JsonViewerProps = {
  data?: object
  rootName: string
}
export const JsonDataViewer = (props: JsonViewerProps) => {
  const theme = useTheme()

  return (
    <JsonViewer
      enableClipboard
      objectSortKeys
      displayDataTypes={false}
      style={theme.palette.mode === 'light' ? lightTheme : darkTheme}
      value={{ [props.rootName]: props.data ?? {} }}
    />
  )
}
